import { TextField, useTheme } from "@mui/material";
import {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from "react";

type Props = {
    filter: any;
    setFilter: Dispatch<SetStateAction<any>>;
    debounceChange?: boolean;
    clear?: boolean;
    label?: any;
};

const SearchBar = ({
    filter,
    setFilter,
    debounceChange = false,
    clear,
    label,
}: Props) => {
    const [searchTerm, setSearchTerm] = useState("");
    const theme = useTheme();
    const searchRef = useRef(0);

    const handleChange = (ev: ChangeEvent<HTMLInputElement>) => {
        const rawValue = ev.target.value;
        const trimmedValue = rawValue.trim(); // Trim leading/trailing spaces

        // Update the visual input with the trimmed value
        setSearchTerm(trimmedValue);

        if (!debounceChange) {
            // Set the filter with the trimmed value immediately
            setFilter({ ...filter, search: trimmedValue });
        } else {
            searchRef.current++;
            const newRef = searchRef.current;

            setTimeout(() => {
                if (newRef === searchRef.current) {
                    // Set the filter with the trimmed value after debounce
                    setFilter({ ...filter, search: trimmedValue });
                    searchRef.current = 0;
                }
            }, 1000);
        }
    };

    useEffect(() => {
        setSearchTerm("");
    }, [clear]);

    return (
        <div style={{ position: "relative", width: "100%" }}>
            <TextField
                fullWidth
                size="small"
                type="text"
                placeholder={label ? label : "Type to Search..."}
                name="query"
                value={searchTerm} // This now reflects the trimmed value
                onChange={handleChange}
                label={label ? label : "Type to Search..."}
                // InputProps={{
                //     startAdornment: (
                //         <Search
                //             fontSize="small"
                //             htmlColor={theme.palette.action.disabled}
                //             sx={{ mr: theme.spacing(1) }}
                //         />
                //     ),
                // }}
            />
        </div>
    );
};

export default SearchBar;
